import { controls, currencyToNumber, grouped } from "../../controls";

const rptgc1 = {
  label: "Total Work Report",
  starting: true,
  url: "rptgc1",
  pageLabel: "Total Work Report",
  pageType: "history",
  // filteraction: true,
  filter: [
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Total Work Report",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },


    extraRows: {
      location: "top",



    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Taluka Name",
        accessor: "taluka_display",
        rwidth: "*"
      },
      {
        Header: "Total No. of Schools",
        accessor: "schools",
      },
      {
        Header: "Non Active Schools",
        accessor: "inactive_schools",
      },
      {
        Header: "Total Saral Data ",
        accessor: "saral_count",
      },
      {
        Header: "probable Match",
        columns: [
          {
            Header: "Total",
            accessor: "total_probable_matches",
          },
          {
            Header: "Work Done",
            accessor: "probable_completed_work",
            align: "right"
          },
          {
            Header: "Pending",
            accessor: "pending_probable",
            align: "right"
          },
        ]
      },
      {
        Header: "System Match",
        columns: [
          {
            Header: "Total",
            accessor: "total_System_matches",
          },
          {
            Header: "Work Done",
            accessor: "system_match_completed",
            align: "right"
          },
          {
            Header: "Pending",
            accessor: "pending_system_match",
            align: "right"
          },
        ]
      },
      {
        Header: "No Match",
        columns: [
          {
            Header: "Total",
            accessor: "total_not_match",
          },
          {
            Header: "Work Done",
            accessor: "completd_not_match",
            align: "right"
          },
          {
            Header: "Pending",
            accessor: "pending_not_match",
            align: "right"
          },
        ]
      },
      {
        Header: "Total Work Done",
        accessor: "work_done",
      },
      {
        Header: "Total Pending Work",
        accessor: "work_pending",
      },
    ]
  }
};

export default rptgc1;